import React, { useState } from "react";
import { checkout } from "../services/api";

export default function Checkout() {
  const [customerName, setCustomerName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [method, setMethod] = useState("Transfer Bank");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await checkout({
        customer_name: customerName,
        phone,
        address,
        method,
      });
      alert(`Order berhasil dibuat. Order ID: ${data.order?.id}`);
    } catch (err) {
      alert("Checkout gagal. Pastikan sudah login dan cart tidak kosong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 520 }}>
      <h2>Checkout</h2>
      <form onSubmit={submit}>
        <div style={{ marginBottom: 8 }}>
          <div>Nama</div>
          <input value={customerName} onChange={(e) => setCustomerName(e.target.value)} style={{ width: "100%" }} />
        </div>
        <div style={{ marginBottom: 8 }}>
          <div>No HP</div>
          <input value={phone} onChange={(e) => setPhone(e.target.value)} style={{ width: "100%" }} />
        </div>
        <div style={{ marginBottom: 8 }}>
          <div>Alamat</div>
          <textarea value={address} onChange={(e) => setAddress(e.target.value)} style={{ width: "100%" }} />
        </div>
        <div style={{ marginBottom: 8 }}>
          <div>Metode Pembayaran</div>
          <select value={method} onChange={(e) => setMethod(e.target.value)}>
            <option>Transfer Bank</option>
            <option>COD</option>
            <option>Midtrans</option>
            <option>Xendit</option>
          </select>
        </div>
        <button disabled={loading} type="submit">
          {loading ? "Loading..." : "Buat Order"}
        </button>
      </form>
    </div>
  );
}
